<template>
  <div class="app-pagination">
    <div>
      総件数
      {{ total.toLocaleString() }}
    </div>

    <div>
      表示件数
      <el-select :value="pageSize" @change="onPageSize">
        <el-option label="10" :value="10" />
        <el-option label="25" :value="25" />
        <el-option label="50" :value="50" />
      </el-select>
    </div>

    <el-pagination
      :current-page="currentPage"
      :total="total"
      :page-size="pageSize"
      @current-change="onCurrentPage"
      layout="prev, pager, next"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import { PropPageSizeType } from './types'

export default defineComponent({
  name: 'AppPagination',
  props: {
    total: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number as PropType<PropPageSizeType>,
      default: 25
    },
    currentPage: {
      type: Number,
      default: 1
    }
  },
  setup(props, context) {
    function onPageSize(pageSize: number) {
      context.emit('paging', {
        pageSize,
        currentPage: 1
      })
    }

    function onCurrentPage(currentPage: number) {
      context.emit('paging', {
        pageSize: props.pageSize,
        currentPage
      })
    }

    return {
      onPageSize,
      onCurrentPage
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.app-pagination {
  display: flex;
  gap: $spacing-unit * 4;
  align-items: center;
}

:deep(.el-input__inner) {
  width: $spacing-unit * 8;
  height: $spacing-unit * 4;
}

:deep(.el-select .el-input .el-select__caret) {
  line-height: $spacing-unit * 3;
}
</style>
